import { imagesHost } from 'config';
import moment from 'moment-business-days';

const addImgAddress = (val)=>{
  if (val && val.indexOf('data:')===0) return val;
  return imagesHost + val;
};


const kFormatter = (num) => Math.abs(num) > 999 ? Math.sign(num) * ((Math.abs(num) / 1000).toFixed(1)) + 'k' : Math.sign(num) * Math.abs(num);
export {kFormatter};


const helpers = {
  data: () => {
    return {
      rulerContainer: null,
      rulerContainerWidth: 0,
      rulerSmCol: null,
      rulerSmColWidth: 0,
      rulerMdCol: null,
      rulerMdColWidth: 0,
      rulerLgCol: null,
      rulerLgColWidth: 0,
    };
  },
  created() {
    this.rulerContainer = document.getElementById('ruler-container');
    if (this.rulerContainer) {
      this.rulerSmCol = this.rulerContainer.querySelector('.col-sm-6');
      this.rulerMdCol = this.rulerContainer.querySelector('.col-md-6');
      this.rulerLgCol = this.rulerContainer.querySelector('.col-lg-6');
      window.onresize = () => {
        this.rulerContainerWidth = this.rulerContainer.offsetWidth;
        this.rulerSmColWidth = this.rulerSmCol.offsetWidth;
        this.rulerMdColWidth = this.rulerMdCol.offsetWidth;
        this.rulerLgColWidth = this.rulerLgCol.offsetWidth;
      };
      window.dispatchEvent(new Event('resize'));
    }
  },
  methods: {
    addImgAddress(val) {
      return addImgAddress(val);
    },
    formatDate(val) {
      return val ? moment(val).format('DD MMM YYYY') : '';
    },
    ahrefsLink(url) {
      return (
        'https://ahrefs.com/site-explorer/overview/v2/prefix/recent?target=' +
        encodeURIComponent(url)
      );
    },
    kFormatter(num) {
      return kFormatter(num);
    },
    setMomentHolidays() {
      if (this.holidays && this.holidays.length) {
        const locale = 'en';
        const hld = this.holidays.map(e=>moment(e).format('YYYY-MM-DD'));
        moment.updateLocale(locale, {
          holidays: hld,
          holidayFormat: 'YYYY-MM-DD',
          workingWeekdays: [1, 2, 3, 4, 5]
        });
        moment.locale(locale);
      }
    },
  },
  computed: {
    isXs() {
      return this.rulerContainerWidth===this.rulerSmColWidth;
    },
    isSm() {
      return this.rulerContainerWidth===this.rulerMdColWidth;
    },
    isMd() {
      return this.rulerContainerWidth===this.rulerLgColWidth;
    },
    holidays() {
      return this.$store.state.campaigns.holidays || [];
    },
  },
  filters: {
    addImgAddress(val) {
      return addImgAddress(val);
    },
    kFormatter(val) {
      return kFormatter(val);
    },
  },
  watch: {
    holidays() {
      this.setMomentHolidays();
    }
  }
};

export default helpers;

